import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userServices from "../userAction";

const initialState = {
  stats: null,
  loading: false,
  error: false,
  success: false,
  message: null,
};

export const userStatDetailsAction = createAsyncThunk(
  "userStatDetailsAction",
  () => {
    return userServices.getMyStats();
  }
);

//CREATE THE SLICE

export const userStatDetailsSlice = createSlice({
  name: "userStatDetails",
  initialState,
  reducers: {
    //non asynchronous reducers goes here
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
      state.message = "";
      state.stats = {};
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(userStatDetailsAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(userStatDetailsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.stats = action.payload?.data;
      })
      .addCase(userStatDetailsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.stats = null;
      });
  },
});

export const { reset } = userStatDetailsSlice.actions;

export default userStatDetailsSlice.reducer;
